export default address => ((address || "").trim()).length > 1;
